import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";

const IndustryFeed = () => {
  const navigate = useNavigate();
  const { peopleInformation } = useSelector((state: any) => state);

  useEffect(() => {
    const peopleInfoStateValidation = peopleInformation ? peopleInformation.data : "";
    if (peopleInfoStateValidation.getpeopleInformation.serviceConfiguration.features.substring(47, 48) === "1") {
      window.open(`${process.env.REACT_APP_PROGRESS_URL}/IndustryFeed?isSimplified=true`, "_blank");
      navigate("/");
    }
  }, [peopleInformation]);

  return (
    <div>
      <ErrorPage status={401} />
    </div>
  );
};

export default IndustryFeed;
